module.exports = __webpack_public_path__ + "img/kashikiri.d769b39c.jpg";